import React, { useState, useEffect } from 'react';
import style from './index.module.scss';
import Slider from 'react-rangeslider'
import { Label } from '../Label';
import { TooltipError } from '../TooltipError'
import VMasker from 'vanilla-masker'

export const MoneySelect = (props) => {
    const [min, setMin] = useState(props.min)
    const [max, setMax] = useState(props.max)
    const [value, setValue] = useState(setMask(props.initial))
    const [valid, setValid] = useState(true)
    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        props.onChange(value)
    }, [value])
    const handleChangeSlider = (val) => {
        let v = setMask(val.toFixed(2))
        setValue(v)
    }

    const handleSelectComplete = () => {
        setMaxRange(parseFloat(value.replaceAll('.','').replaceAll(',','.')))
    }
    const setMaxRange = (v) => {
        if (v < props.max) {
            setMax(props.max)
        }else if (v < max && max < props.max ) {
            setMax(props.max)
        } else if (v >= max) {
            if(v*2 > props.maxValueAllow){
                setMax(props.maxValueAllow)
            } else {
                setMax(v * 2)
            }
        } else if (v <= (max / 2) && max > (props.max*2)) {
            setMax(max / 2)
        }
    } 
    const handleTextChange = (value) => {
        let v = value.target.value
        v = setMask(v)
        if(parseFloat(v.replaceAll('.','').replaceAll(',','.')) <= props.maxValueAllow){
            setValue(v)
            setMaxRange(parseFloat(v.replaceAll('.','').replaceAll(',','.')))
        } else {
            setValid(false)
            setErrorMessage('Máximo de R$ '+setMask(props.maxValueAllow.toFixed(2)))
            setTimeout(()=>setValid(true),3000)
        }
    }

    function setMask(value){
        return VMasker.toMoney(value, {
            precision: 2,
            separator: ',',
            delimiter: '.'
        })
    }

    return (
        <div className={style.main}>
            <div className={style.row}>
                <Label>{props.label}</Label>
                <div className={style.valueInput}>
                    <span className={style.sifrao}>R$</span>
                    <input 
                        className={style.textinput} 
                        onChange={handleTextChange}
                        value={value}
                        type="tel"
                        />
                </div>
            </div>
            {(props.valid && valid)?
                null
            :<TooltipError text={(props.valid === false)?props.errorMessage:errorMessage}/>}
            <div className='sunoRange'>
                <Slider
                    min={min}
                    max={max}
                    tooltip={false}
                    orientation='horizontal'
                    onChange={handleChangeSlider}
                    onChangeComplete={handleSelectComplete}
                    value={parseFloat(value.toString().replaceAll('.','').replaceAll(',','.'))}
                />
            </div>
        </div>
    )
}
